import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui-touch-punch';
var Inputmask = require('inputmask');
import 'bootstrap-sass';
import 'select2';
import 'icheck';
import 'magnific-popup';
import 'jquery.animate-number';
import './calculator'
require('slick-carousel');
import {tracking} from './tracking';

var lcv = lcv || {
    typ_title: 'DZIĘKUJEMY',
    typ_title_small: 'ZA WYPEŁNIENIE FORMULARZA',
    typ_message: '<p>Prosimy oczekiwać kontaktu telefonicznego na podany w formularzu numer telefonu.</p>',
    typ_message_email: '<p>Prosimy oczekiwać wiadomości na podany w formularzu adres e-mail.</p>',
    $carousel: '',
    $carouselLeasing: '',
    $carouselSubscription: '',
    class: {
        isActive: 'is-active',
        isError: 'error',
        hazeError: 'tooltip-error',
        formGroup: 'form-group'
    },
    el: {
        cover: $('.cover-page'),
        nav_toggle: $('.navigation__toggle'),
        visual_bg: $('.section-visual .bg'),
        btnSubmit: $('.js-submit'),
        switch: $('.js-switch-target'),
        formSectionDealer: $('.section--dealer'),
        formSectionCaptcha: $('.section--captcha'),
        nav_list: $('.navigation__list'),
        form: null,
        json_form: null
    },
    obj: {
        dealers: null,
        selectOptions: null,
        gmarkers: [],
        geocoder: null,
        objResults: [],
        dealersObj: []
    },
    option: {
        oldSectionActive: null,
        centerMapLat: null,
        centerMapLng: null,
        radiusMinSearchDealer: 100 * 1000, //100km
        radiusMaxSearchDealer: 300 * 1000 //100km
    },
    field: {
        dealer: $('#dealer_sincom'),
        model: $('#model_id'),
        modelName: $('#model_name'),
        phone: $('#phone'),
        cta: $('#cta'),
        communicationChannel: $('#communication_channel')
    },
    heightVisual: function (windowWidth) {
        var minHeight = {},
            height = window.innerHeight;

        if(selected.financing === 'wynajem') {
            minHeight = {
                    320: 930,
                    480: 930,
                    768: 620,
                    991: 790,
                    1200: 840,
                    1620: 890,
                    1820: 900
                };
            // height = minHeight[windowWidth];
        } else {
            minHeight = {
                    320: 800,
                    480: 800,
                    768: 620,
                    991: 790,
                    1200: 840,
                    1620: 890,
                    1820: 900
                };
        }

        if (height < minHeight[windowWidth])
            height = minHeight[windowWidth];

        return height + "px";
    },
    navigation: {
        init: function () {
            lcv.el.nav_toggle.click(function () {
                lcv.el.nav_toggle.toggleClass(lcv.class.isActive);
                lcv.el.nav_toggle.parent().find('> ul').toggleClass(lcv.class.isActive);
            });

            $('[data-scroll-section]').click(function (e) {
                e.preventDefault();

                var $this = $(this),
                    section = $this.attr('data-scroll-section'),
                    model = $this.attr('data-model'),
                    lead = $this.attr('data-type-lead');

                lcv.navigation.scrollSectionId(section, model, lead);
            });

            if ($(window).scrollTop() > 0) {
                $('.header').addClass('scroll');
            }

            if ($(window).scrollTop() > 50) {
                $('.visual-lfa').addClass('visual-lfa-scroll');
            }

            $(window).scroll(function () {
                if ($(window).scrollTop() > 220) {
                    $('.header').addClass('scroll');

                    if ($(window).scrollTop() > 700) {
                        $('.header').addClass('show-menu');
                    }else{
                        $('.header').removeClass('show-menu');
                    }
                } else {
                    $('.header').removeClass('scroll');
                }

                if ($(window).scrollTop() > 50) {
                    $('.visual-lfa').addClass('visual-lfa-scroll');
                } else {
                    $('.visual-lfa').removeClass('visual-lfa-scroll');
                }

                $('.button-lfa').removeClass('active-lfa');
            });

            $(document).on("scroll", lcv.navigation.onScroll);
        },
        scrollSectionId: function (section, model, lead) {
            var offset,
                windowWidth = document.getElementById('width').offsetWidth;

            if (lcv.el.nav_toggle.hasClass(lcv.class.isActive)) {
                lcv.el.nav_toggle.removeClass(lcv.class.isActive);
                lcv.el.nav_toggle.parent().find('> ul').removeClass(lcv.class.isActive);
            }

            switch (section) {
                case 'section-one':
                    offset = (windowWidth >= 991 ? 90 : 20);
                    break;
                default:
                    offset = (windowWidth >= 991 ? 54 : 0); // Version page desktop and mobile
            }

            if (document.getElementById(section)) {
                window.isScroll = 1;
                var scrollSection = $("body #" + section).offset().top;
                $("html, body").animate({scrollTop: scrollSection - offset}, 400, function () {
                    window.isScroll = 0;
                    $("html, body").animate({scrollTop: scrollSection - offset + 1}, 1);
                });
            }

            if (model) {
                $('#model_id').val(model).trigger('change');
            }

            if (lead) {
                lcv.el.switch.find('[data-value="' + lead + '"]').trigger('click');
            }
        },
        onScroll: function() {
            var scrollPos = $(document).scrollTop();

            lcv.el.nav_list.find('> .navigation__item').each(function(e){
                var $this = $(this),
                    section = $this.find('a, span').attr('data-scroll-section');

                if(typeof section === 'string'){
                    var $sectionEl = $('#' + section),
                        sectionPos = $sectionEl.position().top - 100,
                        sectionHeight = $sectionEl.height();

                    if (sectionPos <= scrollPos && sectionPos + sectionHeight > scrollPos) {

                        lcv.navigation.onScrollActive($this, section);
                    }
                }
            });
        },
        onScrollActive: function ($el, section) {

            if(section != lcv.option.oldSectionActive){
                lcv.option.oldSectionActive = section;

                lcv.el.nav_list.find('li').removeClass(lcv.class.isActive);
                $el.addClass(lcv.class.isActive);

                switch (section) {
                    case 'section-one':
                        if (typeof window.digitalData !== 'undefined') {
                            digitalData.page.pageInfo.linkType = 'content';
                            digitalData.page.pageInfo.linkName = 'content:scroll-what-is';
                        }
                        break;
                    case 'section-two':
                        if (typeof window.digitalData !== 'undefined') {
                            digitalData.page.pageInfo.linkType = 'content';
                            digitalData.page.pageInfo.linkName = 'content:scroll-rules';
                        }
                        break;
                    case 'section-three':
                        if (typeof window.digitalData !== 'undefined') {
                            digitalData.page.pageInfo.linkType = 'content';
                            digitalData.page.pageInfo.linkName = 'content:scroll-benefits';
                        }
                        break;
                    case 'section-models':
                        if (typeof window.digitalData !== 'undefined') {
                            digitalData.page.pageInfo.linkType = 'content';
                            digitalData.page.pageInfo.linkName = 'content:scroll-models';
                        }
                        break;
                    case 'section-form':
                        if (typeof window.digitalData !== 'undefined') {
                            digitalData.page.pageInfo.linkType = 'content';
                            digitalData.page.pageInfo.linkName = 'content:scroll-quote-request';
                        }
                        break;
                }

                // if(section !== 'section-visual') {
                //
                //     if (typeof window.digitalData !== 'undefined') {
                //         _satellite.track("clicklink");
                //     }
                // }
            }
        }
    },
    section: {
        models: function () {
            $('.panel-heading').click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) {
                    $this.parents('.panel-group').find('.panel-heading').removeClass('active');
                } else {
                    $this.parents('.panel-group').find('.panel-heading').removeClass('active');
                    $this.addClass('active');
                }
            });
        },
        background: function(model) {
            lcv.el.visual_bg.find('> div').removeClass(lcv.class.isActive);
            lcv.el.visual_bg.find('[data-model='+model+']').addClass(lcv.class.isActive);
        },
        visual: function () {
            lcv.$carouselLeasing = $('.carousel-leasing');
            lcv.$carouselSubscription = $('.carousel-subscription');

            var windowWidth = document.getElementById('width').offsetWidth,
                windowOldWidth = windowWidth;

            $('#section-visual').css('height', lcv.heightVisual(windowWidth));

            $(window).resize(function () {
                windowWidth = document.getElementById('width').offsetWidth;

                if (windowWidth !== windowOldWidth) {
                    $('#section-visual').css('height', lcv.heightVisual(windowWidth));
                }

                windowOldWidth = windowWidth;

                $('.button-lfa').removeClass('active-lfa');
            });

            lcv.$carouselLeasing.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                swipe: false,
            });

            lcv.$carouselSubscription.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                swipe: false,
            });


            $('.content-subscription.slick-next.slick-arrow').on('click', function(event){
                lcv.$carouselSubscription.slick('slickNext');
            });

            $('.content-subscription.slick-prev.slick-arrow').on('click', function(event) {
                lcv.$carouselSubscription.slick('slickPrev');
            });

            $('.content-leasing.slick-next.slick-arrow').on('click', function(event){
                lcv.$carouselLeasing.slick('slickNext');
            });

            $('.content-leasing.slick-prev.slick-arrow').on('click', function(event) {
                lcv.$carouselLeasing.slick('slickPrev');
            });

            // lcv.$carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //     lcv.section.background(lcv.$carousel.find('[data-slick-index=' + nextSlide + ']').attr('data-model'));
            //     // $('.carousel-model-headline').html('W LEASINGU 2<br />102% <small class="small-text">');
            //     // $('.carousel-model-headline').html('W LEASINGU<br />102%');
            // });

            lcv.$carouselSubscription.on('afterChange', function(event, slick, currentSlide, nextSlide){
                $('.content-subscription.carousel-nav__item').removeClass(lcv.class.isActive);
                $(".content-subscription.carousel-nav__item[data-slide-id="+currentSlide+"]").addClass(lcv.class.isActive);
            });

            lcv.$carouselLeasing.on('afterChange', function(event, slick, currentSlide, nextSlide){
                $('.content-leasing.carousel-nav__item').removeClass(lcv.class.isActive);
                $(".content-leasing.carousel-nav__item[data-slide-id="+currentSlide+"]").addClass(lcv.class.isActive);
            });

            $('.content-subscription.carousel-nav__item').click(function(){
                var $this = $(this),
                    $dataSlideID = $this.attr('data-slide-id');

                $('.content-subscription.carousel-nav__item').removeClass(lcv.class.isActive);
                $this.addClass(lcv.class.isActive);
                lcv.$carouselSubscription.slick('slickGoTo', $dataSlideID);
            });

            $('.content-leasing.carousel-nav__item').click(function(){
                var $this = $(this),
                    $dataSlideID = $this.attr('data-slide-id');

                $('.content-leasing.carousel-nav__item').removeClass(lcv.class.isActive);
                $this.addClass(lcv.class.isActive);
                lcv.$carouselLeasing.slick('slickGoTo', $dataSlideID);
            });
        },
        init: function () {
            this.visual();
            this.models();
        }
    },
    form: {
        init: function (form, financing) {
            var $section_form = $('#section-form');
            $section_form.hide();
            if (financing === 'leasing') {
                if(offer.leasing === '1') {
                    $.getJSON(form_leasing, function(json_form){
                        lcv.el.json_form = json_form;
                        $section_form.show();
                        lcv.form.create(form, financing);
                    });
                } else {
                    $.getJSON(form_maintenance_leasing, function(json_form){
                        lcv.el.json_form = json_form;
                        $section_form.show();
                        lcv.form.create(form, financing);
                    });
                }
            } else if (financing === 'subscription') {
                if(offer.subscription === '1') {
                    $.getJSON(form_subscription, function (json_form) {
                        lcv.el.json_form = json_form;
                        $section_form.show();
                        lcv.form.create(form, financing);
                    });
                } else {
                    $.getJSON(form_maintenance_subscription, function (json_form) {
                        lcv.el.json_form = json_form;
                        $section_form.show();
                        lcv.form.create(form, financing);
                    });
                }
            }
        },
        create: function(form, financingName) {
            var $form_loader = $('#form-loader'),
                $form_header = $('#form-header');

            $form_header.show();
            $form_loader.hide();

            var code = '<form action="' + submit_form + '" method="post" class="order-form">',
                code_fields = {
                    firstname: '',
                    lastname: '',
                    company: '',
                    communication_channel: '',
                    email: '',
                    repeat_email: '',
                    phone: '',
                    zipcode: '',
                    dealers: '',
                    captcha: '',
                    required: '',
                    required_star: '',
                    agreements: '',
                    energy_type: 'ICE',
                };

            $.each(lcv.el.json_form.fields, function (name, value) {
                switch (value.type) {
                    case 'text':
                        if (value.name === 'firstname' ||
                            value.name === 'lastname' ||
                            value.name === 'phone' ||
                            value.name === 'zipcode'
                        ) {
                            if (value.required) {
                                code_fields.required_star = '*';
                                code_fields.required = 'required';
                            } else {
                                code_fields.required_star = '';
                                code_fields.required = '';
                            }

                            code_fields[value.name] += '<div class="form-group is-no-label col-sm-6"> ' +
                                '<input type="' + value.type +  '" class="form-control" id="' + value.name + '" name="' + value.name + '"' +
                                'placeholder="' + value.placeholder + code_fields.required_star + '" ' + code_fields.required + '/></div>';
                        } else if (value.name === 'company' ) {
                            code_fields[value.name] += '<div class="row">' +
                                '<div class="form-group is-no-label col-sm-12">' +
                                '<input type="text" class="form-control" id="' + value.name + '" name="' + value.name + '" placeholder="' + value.placeholder + '"/>' +
                                '</div></div>';
                        }


                        break;
                    case 'email':
                        if (value.name === 'email' ||
                            value.name === 'repeat_email') {
                            if (value.required) {
                                code_fields.required_star = '*';
                                code_fields.required = 'required';
                            } else {
                                code_fields.required_star = '';
                                code_fields.required = '';
                            }

                            code_fields[value.name] += '<div class="form-group is-no-label col-sm-6"> ' +
                                '<input type="' + value.type + '" class="form-control" id="' + value.name + '" name="' + value.name + '"' +
                                'placeholder="' + value.placeholder + code_fields.required_star + '" ' + code_fields.required + '/></div>';
                        }
                        break;
                    case 'select':
                        if (value.input && value.name === 'communication_channel') {
                            // code_fields.communication_channel += '<div class="row--preferred-contact row"><div class="form-group col-sm-6"><label for="communication_channel">' + value.label + '</label></div>';
                            // code_fields.communication_channel += '<div class="form-group col-sm-6"><select id="communication_channel" name="communication_channel" class="form-control" style="width: 100%">';
                            //
                            // $.each(value.input, function (key, value) {
                            //     code_fields.communication_channel += '<option value="' + value.value + '">' + value.label + '</option>';
                            // });
                            // code_fields.communication_channel += '</select></div></div>';

                            // FCAGENERAL-117 Wyłączenie preferowanego kontaktu przez e-mail
                            code_fields.communication_channel += '<input type="hidden" id="communication_channel" name="communication_channel" value="T" />';
                        } else if (value.name === 'dealer_sincom') {

                            code_fields.dealers += '<fieldset class="section--2 section--dealer is-active"><div class="fields-wrapper">' +
                                '<div class="row"><div class="form-group is-no-label col-xs-12">' +
                                '<select class="form-control js-dealer-select" id="' + value.name + '"' +
                                'name="' + value.name + '" style="width: 100%"><option value="">Wybierz dealera</option>' +
                                '</select></div></div></div><div class="dealer-list js-dealer-list__instance">' +
                                '<ul class="dealer-list__list js-dealer-list__list"></ul></div>' +
                                '<div id="dealer-dropdown" class="show-btn-all-dealers"></div></fieldset>';
                        } else if (value.name === 'model_id'){

                            code += '<fieldset class="section--1 section--brand-and-model"><div class="fields-wrapper"><div class="row"><div class="form-group is-no-label col-xs-12"><select class="form-control" id="model_id" name="model_id" style="width: 100%">';
                            $.each(value.input, function (key, value) {
                                code += '<option value="' + value.value + '">' + value.label + '</option>';
                            });
                            code += '</select></div></div></div></fieldset>';
                        }
                        break;
                    case 'recaptcha':
                        code_fields.captcha = '<fieldset class="section--4 section--captcha section--sticky" style="display: none">' +
                            '<div class="row"><div class="form-group col-xs-12 text-center"><div class="g-recaptcha" data-sitekey="' + value.recaptcha.site_key + '">' +
                            '</div></div></div></fieldset>';
                        break;
                    default:
                        if(value.name === 'cta') {
                            code += '<fieldset class="section--2 section--target-form"><ul class="switch-target list-unstyled js-switch-target clearfix">';

                                $.each(value.input, function (key, value) {
                                    if (value.value === 'RP') {
                                        code += '<li class="is-active" data-value="RP" data-btn-text="Wyślij"><span>Chcę otrzymać ofertę na samochód</span></li>';
                                    } else if (value.value === 'TD') {
                                        code += '<li data-value="TD" data-btn-text="Wyślij"><span>Chcę odbyć jazdę testową</span></li>';
                                    }
                                });
                            code += '</ul><input type="hidden" id="' + value.name + '" value="RP" name="' + value.name + '"></fieldset>';
                        }
                }

            });

            if (lcv.el.json_form.disclaimer !== undefined) {
                code_fields.agreements += '<div id="privacy-notes" class="mfp-hide white-popup-block">' +
                    '' + lcv.el.json_form.disclaimer.information.content['privacy-notes'] +
                    '</div>';
            }

            code_fields.agreements += '<fieldset class="section--5 section--agreements"><div class="fields-wrapper"><div class="accept-privacy clear">';
            code_fields.agreements += '<p class="privacy-notes">Po przeczytaniu i zrozumieniu niniejszej <a href="#privacy-notes">Polityki Prywatności</a>, ' +
                'wyrażam zgodę na przetwarzanie moich Danych w następujących celach:</p>';

            code_fields.agreements += '<div class="form-accordion-agreements">';
            $.each(lcv.el.json_form.agreements, function (key, value) {
                code_fields.agreements += '<div class="form-accordion-agreement fields-' + value.inputs[0].name + ' accordion-agreement--is-open">';
                code_fields.agreements += '<div class="accordion-agreement--title">' + value.label +
                    '<div class="accordion-agreement-arrow">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">' +
                    '<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>' +
                    '</svg></div>' +
                    '</div>';

                code_fields.agreements += '<div class="accordion-agreement--description">' + value.content_after + '</div>';

                code_fields.agreements += '<div class="form-group ' + value.type + '">';
                code_fields.agreements += '<div class="wrap-input">';
                $.each(value.inputs, function (inputs_key, inputs_value) {
                    code_fields.agreements += '<label> ' +
                        '<input type="' + value.type + '" name="' + inputs_value.name + '" value="' + inputs_value.value + '"' +
                        'class="js-form-perm-' + inputs_key + '"/>' + inputs_value.label +
                        '</label>';
                });

                code_fields.agreements += '</div>';

                code_fields.agreements += '</div>';
                code_fields.agreements += '</div>';

            });
            code_fields.agreements += '</div>';

            code_fields.agreements += '</div></div></fieldset>';
            code += '<input type="hidden" name="form_id" value="' + lcv.el.json_form.id + '" />';

            code += '<fieldset class="section--3 section--personal-data"><div class="fields-wrapper">' +
                '<div class="row"><div class="requirement-note">* Pola obowiązkowe</div>';

            code += code_fields.firstname + code_fields.lastname + '</div>';
            code += code_fields.company + code_fields.communication_channel;
            code += '<div class="row">' + code_fields.email + code_fields.repeat_email + '</div>';
            code += '<div class="row">' + code_fields.phone + code_fields.zipcode + '</div>';
            code += '</div></fieldset>';
            code += code_fields.dealers;
            code += code_fields.agreements;
            code += code_fields.captcha;
            code += '<fieldset class="section--6 section--submit"><div class="fields-wrapper text-center">' +
                '<button type="submit" class="button js-submit">Wyślij</button></div></fieldset>';
            code += '</form>';

            $('.js-form').html(code);

            $('.accordion-agreement--title').click(function(e) {
                const elem = $(this).parent();
                if (elem.hasClass('accordion-agreement--is-open')) {
                    elem.removeClass('accordion-agreement--is-open');
                } else {
                    elem.addClass('accordion-agreement--is-open');
                }
            });

            $('.accordion-agreement--description a').click(function(e) {
                if (e.target.href) {
                    if(e.target.href.includes('#privacy-notes')) {
                        e.preventDefault();
                        $.magnificPopup.open({
                            type: 'inline',
                            mainClass: 'popup-contents',
                            alignTop: true,
                            overflowY: 'scroll',
                            myClassOne: 'content-popup',
                            items: {
                                src: '#privacy-notes'
                            },
                        });
                    }
                }
            });

            lcv.popupLink();

            lcv.field.model = $('#model_id');
            lcv.field.cta = $('#cta');
            lcv.field.communicationChannel = $('#communication_channel');
            lcv.field.phone = $('#phone');
            lcv.field.dealer = $('#dealer_sincom');

            lcv.el.switch = $('.js-switch-target');
            lcv.el.formSectionDealer = $('.section--dealer');
            lcv.el.formSectionCaptcha = $('.section--captcha');
            lcv.el.btnSubmit = $('.js-submit');

            lcv.form.change_switch();
            lcv.obj.selectOptions = null;
            lcv.obj.gmarkers = [];

            lcv.el.form = $(form);

            lcv.field.model.select2({
                minimumResultsForSearch: Infinity
            });

            let modelToSet = '';
            $.each(financing[financingName], function (key, val) {

                if (modelToSet === '') {
                    modelToSet = key;
                }

                if (val.slug === selected.model) {
                    modelToSet = key;
                }

                lcv.field.model.val(modelToSet).trigger('change');
            });

            // FCAGENERAL-117 Wyłączenie preferowanego kontaktu przez e-mail
            // lcv.field.communicationChannel.select2({
            //     minimumResultsForSearch: Infinity
            // });

            $.getScript("https://www.google.com/recaptcha/api.js");

            Inputmask('+48 999-999-999').mask('#phone');

            Inputmask('99-999', {
                clearIncomplete: true,
                onBeforeWrite: function (event, buffer, caretPos, opts) {
                    if (caretPos >= 5) {
                        lcv.form.show_dealer(false);
                        lcv.field.dealer.prop('disabled', true);
                    }
                },
                oncomplete: function () {
                    lcv.form.show_dealer(true);
                },
                oncleared: function () {
                    lcv.form.show_dealer(false);
                    lcv.field.dealer.prop('disabled', true);
                }
            }).mask('#zipcode');

            // Dealers
            lcv.searchDealer.init();
            // / Dealers

            lcv.field.communicationChannel.on("select2:select, change", function (e) {
                var $this = $(this),
                    selectVal = $this.val(),
                    placeholderMobileNumber = ['Numer telefonu*', 'Numer telefonu'];

                if (selectVal === "T" || selectVal === "V") {
                    lcv.field.phone.attr('placeholder', placeholderMobileNumber[0]).prop('required', 1);
                } else {
                    lcv.field.phone.attr('placeholder', placeholderMobileNumber[1]).prop('required', 0);
                }

                if(lcv.field.phone.parents('.' + lcv.class.formGroup).hasClass(lcv.class.isError)) {
                    lcv.field.phone.parents('.' + lcv.class.formGroup).removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                        $(this).remove();
                    });
                }
            });

            lcv.field.model.on("select2:select, change", function (e) {
                // ADOBE //
                if (financing[financingName][lcv.field.model.val()]) {
                    tracking.adobe.changeModelForForm(
                      lcv.field.cta.val(),
                      financing[financingName][lcv.field.model.val()]['adobe_VehicleID'],
                      financing[financingName][lcv.field.model.val()]['adobe_VehicleModel'],
                      financing[financingName][lcv.field.model.val()]['adobe_VehicleModelName'],
                      financing[financingName][lcv.field.model.val()]['adobe_vehicleEngine'],
                      financing[financingName][lcv.field.model.val()]['adobe_VehicleTrim']);
                }
                // / ADOBE //
            });

            $('.order-form input[type=checkbox], .order-form input[type=radio]').iCheck({
                checkboxClass: 'icheckbox',
                radioClass: 'iradio'
            });

            lcv.el.form.on('click, focus', 'input[type="text"], input[type="email"], input[type="tel"], textarea, .dk-select, .select2-container, select, .model, .ui-selectmenu-button', function () {
                var $this = $(this);

                $this.parents('.' + lcv.class.formGroup).removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                    $(this).remove();
                });
            });

            lcv.el.form.on('mouseover', '.g-recaptcha', function () {
                var $this = $(this);

                $this.parent().removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                    $(this).remove();
                });
            });

            $('input').on('ifChecked', function (event) {
                var $this = $(this);

                if ($this.parents('.' + lcv.class.formGroup).hasClass(lcv.class.formGroup)) {
                    $this.parents('.' + lcv.class.formGroup).removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                        $(this).remove();
                    });

                    if ($this.parents('.' + lcv.class.formGroup).hasClass('js-member-jog'))
                        if ($this.parent().find('input').val() == 1)
                            $this.parents('.form-part').find('.form-hidden').show();
                        else
                            $this.parents('.form-part').find('.form-hidden').hide();
                } else {
                    $this.parents('.form-part').removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                        $(this).remove();
                    });
                }
            });

            $('input#email, input#email_confirm').on('paste', function (e) {
                e.preventDefault();
            });

            var $js_form = $('.js-form'),
                $form__h2 = $('.form__h2'),
                $section_form = $('#section-form');

            lcv.el.btnSubmit.click(function (e) {
                e.preventDefault();

                let energyType = '&energy_type=';
                $.each(financing[financingName], function (index, value) {
                    if (lcv.field.model.val() === index) {
                        energyType += value.adobe_vehicleEngine;
                    }
                });

                var $this = $(this),
                    url_action = lcv.el.form.attr('action');

                lcv.form.coverPage(true);

                $form_header.hide();
                $js_form.hide();
                $form__h2.hide();
                $form_loader.show();
                $section_form.find('.bg, .bg_2').hide();

                lcv.navigation.scrollSectionId('section-form');

                setTimeout(function() {
                    $.ajax({
                        type: "POST",
                        url: url_action,
                        data: lcv.el.form.serialize().replace('5103-doblo-combi','5103') + energyType
                    })
                        .done(function (result) {
                            $js_form.show();
                            $form_header.show();
                            $form_loader.hide();
                            $section_form.find('.bg, .bg_2').show();

                            switch (result.status) {
                                case 0: // error
                                    var errors = result.errors;
                                    $('.' + lcv.class.formGroup).removeClass(lcv.class.isError);
                                    $('.' + lcv.class.hazeError).remove();

                                    $.each(errors, function (field, error_msg) {
                                        lcv.form.createErrorMSG(field, error_msg[0]);
                                    });

                                    lcv.form.scrollFirstError();
                                    break;
                                case 1: // success
                                    $('#section-form .headline h1').html(lcv.typ_title);
                                    $('#section-form .headline h3').html(lcv.typ_title_small);
                                    $('#section-form').find('.bg, .bg_2').remove();
                                    $('.js-form').append('<fieldset class="section--1 section--typ"><div class="fields-wrapper"><div class="row"><div class="col-xs-12">' + (lcv.field.communicationChannel.val() === 'M' ? lcv.typ_message_email : lcv.typ_message) + '</div></div></div> </fieldset>');

                                    lcv.el.form.remove();

                                    $('.' + lcv.class.formGroup).removeClass(lcv.class.isError);
                                    $('.' + lcv.class.hazeError).remove();

                                    tracking.adobe.formSubmit(result[0]['lead_id']);

                                    lcv.navigation.scrollSectionId('section-form');

                                    lcv.form.reset();

                                    if (result.redirect)
                                        window.location.href = result.redirect;
                                    break;
                                case 2: // redirect
                                    if (result.redirect)
                                        window.location.href = result.redirect;
                                    break;
                            }

                            // $js_form.show();
                            // $form_header.show();
                            // $form_loader.hide();
                            // $section_form.find('.bg, .bg_2').show();

                        })
                        .fail(function (result) {
                            $form_header.show();
                            $js_form.show();
                            if ((selected.financing === 'leasing' && offer.leasing === '' ||
                                selected.financing === 'wynajem' && offer.subscription === ''
                            )) {
                                $form__h2.show();
                            }
                            $form_loader.hide();
                            $section_form.find('.bg, .bg_2').show();

                            if (result.status === 400) {
                                var errors = result.responseJSON.errors;
                                $('.' + lcv.class.formGroup).removeClass(lcv.class.isError);
                                $('.' + lcv.class.hazeError).remove();

                                $.each(errors, function (field, error_msg) {
                                    lcv.form.createErrorMSG(field, error_msg[0]);
                                });

                                lcv.form.scrollFirstError();
                            } else {
                                alert('Wystąpił nieoczekiwany błąd, spróbuj ponownie.');
                            }

                            // $form_header.show();
                            // $js_form.show();
                            // $form_loader.hide();
                            // $section_form.find('.bg, .bg_2').show();

                        })
                        .always(function () {
                            lcv.form.coverPage(false);
                        });

                    grecaptcha.reset();
                }, 500);

            });

            lcv.el.btnSubmit.prop('disabled', false);
        },
        show_dealer: function (status) {
            this.removeErrorMSG('zipcode');
            this.removeErrorMSG('dealer_sincom');

            switch (status) {
                case true:
                    lcv.el.formSectionDealer.find('input, select').val('');
                    lcv.searchDealer.codeAddress(lcv.option.radiusMinSearchDealer);
                    break;
                default:
                    lcv.el.formSectionDealer.find('input, select').val('');
                    lcv.el.formSectionDealer.select2.defaults.reset();
            }
        },
        change_switch: function () {
            lcv.el.switch.find('li').click(function () {
                var $this = $(this),
                    cta = $this.attr('data-value');

                if (!$this.hasClass(lcv.class.isActive)) {
                    lcv.el.switch.find('li').removeClass(lcv.class.isActive);
                    $this.addClass(lcv.class.isActive);
                    lcv.field.cta.val(cta);
                    lcv.el.btnSubmit.val($this.attr('data-btn-text'));

                    // ADOBE //
                    tracking.adobe.changeType(lcv.field.cta.val());
                    // / ADOBE //
                }
            });

            $('body').on('click', '.js-change-type', function () {
                lcv.el.switch.find('li').each(function () {
                    var $this = $(this);

                    if (!$this.hasClass(lcv.class.isActive)) {
                        $this.trigger('click');
                        return false;
                    }

                })
            });
        },
        scrollFirstError: function () {
            var scrollFirstError = $("body ." + lcv.class.hazeError + ":first").parents('.' + lcv.class.formGroup).offset().top;
            $("html, body").animate({scrollTop: scrollFirstError - $('.header').height() - 60}, 400);
        },
        removeErrorMSG: function (field) {
            var $this = $("[name=" + field + "]");
            $this.parent().removeClass(lcv.class.isError).find('.' + lcv.class.hazeError).fadeOut(300, function () {
                $(this).remove();
            });
        },
        createErrorMSG: function (field, error_msg) {
            var $this = $("[name=" + field + "]"),
                added_val,
                agreement_fields = ['agreement_marketing', 'agreement_profiling', 'agreement_3rdpartymarketing'];

            if ($this.parents('.' + lcv.class.formGroup).hasClass('is-no-label'))
                added_val = -9;
            else
                added_val = 15;

            if($.inArray(field, agreement_fields) >= 0) {
                $this.parents('.wrap-input').addClass(lcv.class.isError)
                    .append('<span class="' + lcv.class.hazeError + '">' + error_msg + '</span>')
                    .find('.' + lcv.class.hazeError).fadeIn(300).css({'top': -($this.parents('.' + lcv.class.formGroup).find('.' + lcv.class.hazeError).height() + 9)});
            } else {
                if ($this.parents('.' + lcv.class.formGroup).hasClass(lcv.class.formGroup)) {
                    $this.parents('.' + lcv.class.formGroup).addClass(lcv.class.isError)
                        .append('<span class="' + lcv.class.hazeError + '">' + error_msg + '</span>')
                        .find('.' + lcv.class.hazeError).fadeIn(300).css({'top': -($this.parents('.' + lcv.class.formGroup).find('.' + lcv.class.hazeError).height() - added_val)});
                } else {
                    $this.parents('.form-part').addClass(lcv.class.isError)
                        .append('<span class="' + lcv.class.hazeError + '">' + error_msg + '</span>')
                        .find('.' + lcv.class.hazeError).fadeIn(300).css({'top': -($this.parents('.' + lcv.class.formGroup).find('.' + lcv.class.hazeError).height())});
                }
            }
        },
        coverPage: function (show) {
            var showStatus = typeof show !== 'undefined' ? show : false;

            if (showStatus)
                lcv.el.cover.fadeIn(200);
            else
                lcv.el.cover.fadeOut(200);
        },
        reset: function () {
            lcv.el.form[0].reset();
        },
    },
    searchDealer: {
        compare: function (a, b) {
            return a.address.city.localeCompare(b.address.city)
        },
        compareNumbers: function (a, b) {
            return a.distance - b.distance
        },
        createMarker: function (latlng, name, html, date_dealer) {
            var contentString = html;
            var marker = new google.maps.Marker({
                position: latlng,
                title: name,
                dealerId: date_dealer.sincom,
                date_dealer: {
                    name: date_dealer.name,
                    address: date_dealer.address,
                    email: date_dealer.email,
                    phones: date_dealer.phones
                },
                zIndex: Math.round(latlng.lat() * -100000) << 5
            });

            lcv.obj.gmarkers.push(marker);

            lcv.obj.selectOptions += '<option value="' + date_dealer.sincom + '">' + name + '<\/option>';
        },
        showAllDealers: function () {
            lcv.obj.selectOptions = null;
            lcv.obj.dealers = null;
            lcv.obj.dealers = Object.values(lcv.el.json_form.form_dealers);

            lcv.obj.dealers.sort(lcv.searchDealer.compare);

            lcv.obj.selectOptions += '<option disabled selected>Wybierz dealera</option>';

            $.each(lcv.obj.dealers, function (key, data) {
                lcv.obj.selectOptions += '<option value="' + data.sincom + '">' + data.address.city + ', ' + data.address.street + ' - ' + data.name + '<\/option>';
            });
            $('#dealer-dropdown').removeClass('show-btn-all-dealers');
            document.getElementById("dealer_sincom").innerHTML = lcv.obj.selectOptions;
            lcv.field.dealer.trigger('change.select2');
            lcv.field.dealer.select2('open');
            lcv.field.dealer.prop("disabled", false);
        },
        codeAddress: function (radius) {

            var postal_code = document.getElementById('zipcode').value;

            if (postal_code == '') {
                lcv.form.createErrorMSG('zipcode', 'Wpisz kod pocztowy.');
                lcv.form.scrollFirstError();
            } else {
                lcv.obj.geocoder.geocode({
                    componentRestrictions: {
                        country: 'PL',
                        postalCode: postal_code
                    }
                }, function (results, status) {

                    if (status == google.maps.GeocoderStatus.OK) {
                        lcv.obj.selectOptions = '<option disabled selected>Wybierz dealera</option>';
                        var searchCenter = results[0].geometry.location;
                        var bounds = new google.maps.LatLngBounds();
                        var foundMarkers = 0;

                        lcv.option.centerMapLat = searchCenter.lat();
                        lcv.option.centerMapLng = searchCenter.lng();

                        lcv.obj.results = [];

                        for (var i = 0; i < lcv.obj.gmarkers.length; i++) {
                            if (google.maps.geometry.spherical.computeDistanceBetween(lcv.obj.gmarkers[i].getPosition(), searchCenter) < radius) {
                                bounds.extend(lcv.obj.gmarkers[i].getPosition());
                                lcv.obj.results.push({
                                    'id': lcv.obj.gmarkers[i].dealerId,
                                    'title': lcv.obj.gmarkers[i].title,
                                    'data_dealer': lcv.obj.gmarkers[i].date_dealer,
                                    'lat': lcv.obj.gmarkers[i].position.lat(),
                                    'lon': lcv.obj.gmarkers[i].position.lng(),
                                    'distance': google.maps.geometry.spherical.computeDistanceBetween(lcv.obj.gmarkers[i].position, searchCenter)
                                });

                                foundMarkers++;
                            } else {
                                lcv.obj.gmarkers[i].setMap(null);
                            }
                        }

                        lcv.obj.results.sort(lcv.searchDealer.compareNumbers);

                        for (var i = 0, len = lcv.obj.results.length; i < len; i++) {
                            lcv.obj.selectOptions += '<option value="' + lcv.obj.results[i].id + '">' + lcv.obj.results[i].title + '<\/option>';
                        }
                        if (radius <= lcv.option.radiusMaxSearchDealer)
                            lcv.obj.selectOptions += '<option value="all-dealers">Pokaż wszystkich dealerów<\/option>';

                        if (lcv.obj.results.length != 0 && lcv.obj.results.length >= 3) {
                            document.getElementById("dealer_sincom").innerHTML = lcv.obj.selectOptions;
                            lcv.field.dealer.trigger('change.select2');
                            lcv.field.dealer.select2('open');
                            lcv.field.dealer.prop("disabled", false);
                            lcv.form.removeErrorMSG('zipcode');
                            lcv.el.formSectionDealer.fadeIn(300).addClass(lcv.class.isActive);
                            lcv.el.formSectionCaptcha.fadeIn(300).addClass(lcv.class.isActive);
                            $('#dealer-dropdown').addClass('show-btn-all-dealers');
                        } else {
                            var increased_radius = parseInt(radius) + (50 * 1000);

                            if (increased_radius <= lcv.option.radiusMaxSearchDealer) {
                                lcv.searchDealer.codeAddress(increased_radius);
                            } else {
                                lcv.form.createErrorMSG('zipcode', 'Nie znaleziono dealera.');
                                lcv.form.scrollFirstError();
                            }
                        }

                    } else {
                        lcv.form.createErrorMSG('zipcode', 'Nieprawidłowy kod pocztowy.');
                        lcv.form.scrollFirstError();
                    }
                });
            }
        },
        setMarkers: function (map, markersDealers) {
            var contentString,
                infowindow = new google.maps.InfoWindow();

            for (var i = 0; i < markersDealers.length; i++) {
                var dataDealer = markersDealers[i];


                var marker = new google.maps.Marker({
                    position: {lat: dataDealer['lat'], lng: dataDealer['lon']},
                    map: map,
                    icon: base_url + 'assets/img/map_icon.webp',
                    title: dataDealer['title'],
                    dealer_sincom: dataDealer['id']
                });

                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {
                        var dealer_phones = '';

                        for (var i2 = 0; i2 < markersDealers[i]['data_dealer']['phones'].length; i2++) {
                            dealer_phones += 'tel: ' + markersDealers[i]['data_dealer']['phones'][i2] + '</br>';
                        }

                        contentString = '<div class="info-map">' +
                            '<div class="desc">' +
                            '<b>' + markersDealers[i]['data_dealer']['name'] + '</b><br />' +
                            markersDealers[i]['data_dealer']['address']['street'] + '<br />' +
                            markersDealers[i]['data_dealer']['address']['post_code'] + ', ' + markersDealers[i]['data_dealer']['address']['city'] + '<br />' +
                            dealer_phones +
                            'email: <a href="mailto:' + markersDealers[i]['data_dealer']['email'] + '">' + markersDealers[i]['data_dealer']['email'] + '</a><br><br>' +
                            '<span class="btn btn-primary js-select-dealer" data-dealer-id="' + markersDealers[i]['id'] + '">wybierz dealera</span>' +
                            '</div>' +
                            '</div>';

                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);
                    }
                })(marker, i));
            }

            $('#map').on('click', '.js-select-dealer', function () {
                var $this = $(this);
                lcv.field.dealer.val($this.attr('data-dealer-id')).trigger("change");
                lcv.form.removeErrorMSG('dealer_sincom');
                $.magnificPopup.close();
            });
        },
        init: function () {
            lcv.obj.selectOptions = null;
            lcv.option.dealersObj = [];
            lcv.obj.dealers = [];
            lcv.obj.dealers = [lcv.el.json_form.form_dealers];

            lcv.obj.dealers.sort(lcv.searchDealer.compare);

            lcv.obj.selectOptions += '<option disabled selected>Wybierz dealera</option>';


            $.each(lcv.obj.dealers[0], function (key, data) {
                var point = new google.maps.LatLng(data.coordinates.latitude, data.coordinates.longitude);

                var html = "<b>" + data.name + "</b><br>";
                var marker = lcv.searchDealer.createMarker(point, data.address.city + ', ' + data.address.street + ' - ' + data.name, html, data);

                lcv.option.dealersObj[data.sincom] = {'name': data.name, 'simcom': data.code};
            });

            document.getElementById("dealer_sincom").innerHTML = lcv.obj.selectOptions;
            // Create dealer select

            lcv.field.dealer.select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $('#dealer-dropdown'),
                data: null
            });
            // lcv.field.dealer.select2('data', null);
            lcv.field.dealer.on("select2:select", function (e) {
                if (lcv.field.dealer.val() == 'all-dealers')
                    lcv.searchDealer.showAllDealers();
            });

            lcv.field.dealer.prop("disabled", true);
        }
    },
    popupLink: function () {

        $('.js-popup-link').magnificPopup({
            type: 'ajax',
            mainClass: 'popup-contents',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function () {
                    return this.content;
                }
            }
        });

        $('.accept-privacy .privacy-notes a').magnificPopup({
            type: 'inline',
            mainClass: 'popup-contents',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                }
            }
        });

        $('.accept-privacy .form-group a').magnificPopup({
            type: 'inline',
            mainClass: 'popup-contents-mini',
            alignTop: true,
            overflowY: 'scroll',
            myClassOne: 'content-popup',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='content-popup'>" + mfpResponse.data + "</div>";
                }
            }
        });
    },
    modal: function () {
        $('.js-modal').magnificPopup({
            type: 'inline',
            preloader: false,
            mainClass: 'popup-contents'
        });
    },
    checkGoogleObj: function(form) {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            if(selected.financing === 'wynajem') {
                this.form.init(form, 'subscription');
            } else {
                this.form.init(form, 'leasing');
            }
            lcv.obj.geocoder = new google.maps.Geocoder();
            lcv.form.init(form);
        } else {
            // lcv.form.createErrorMSG('zipcode', 'Problem z wczytaniem API Google.');
            // lcv.form.scrollFirstError();
            setTimeout(() => {
                this.checkGoogleObj(form);
            },1000);
        }
    },
    init: function (form) {
        this.navigation.init();
        this.section.init();
        this.checkGoogleObj(form);
        this.popupLink();
        this.modal();
    }
};

$(document).ready(function () {
    var isScroll = 0;

    lcv.init('.order-form');

    if (selected.model !== '') {
        $('[data-car-slug=' + selected.model + ']').click();
    }
    // $('.carousel-model-headline').html('W LEASINGU<br />102%');

    lazyLoad();
    registerListener('scroll', lazyLoad);
    registerListener('resize', lazyLoad);

    $('#lfa-link-configurator').on('click', function(){
        sendFloodlight('10176142', 'fp_butto', 'fp_but_k');
    });

    $('#lfa-link-stocklocator').on('click', function(){
        sendFloodlight('10176142', 'fp_butto', 'fp_but_d');
    });

    $('.lfa-link-dealer-locator').on('click', function(){
        sendFloodlight('10176142', 'fp_butto', 'fp_but_z');
    });

    $('.lfa-touch').on('click touchstart', function(e){
        e.preventDefault();
        e.stopPropagation();
        $('.lfa-touch').parent().removeClass('active-lfa');
        $(this).parent().addClass('active-lfa');
    });

    $("body").on('click', function(e){
        $('.button-lfa').removeClass('active-lfa');
    });

    if (findGetParameter('source').toLowerCase() === 'sem') { // FCAJWYNAJEM-5 Ukrycie linków LFA
        $('.visual-lfa').hide();
    }

    $("[data-financing]").on('click', function (e) {
        e.preventDefault();

        $("html, body").animate({scrollTop: 0}, 300);

        if ($(this).attr('data-financing') === 'leasing') {
            setFinancing('leasing');
        } else {
            setFinancing('subscription');
        }

    });

    if(selected.financing === 'wynajem') {
        $('.content-leasing').hide();
        $('.content-subscription').show();
        $('.content-leasing').addClass('hidden');
        $('.content-subscription').removeClass('hidden');
        $('.site').addClass('subscription').removeClass('leasing');

    } else {
        $('.content-leasing').show();
        $('.content-subscription').hide();
        $('.content-leasing').removeClass('hidden');
        $('.content-subscription').addClass('hidden');
        $('.site').addClass('leasing').removeClass('subscription');
    }

    AOS.init({
        offset: 100,
        delay: 100,
    });

    window.onpopstate = function () {
        if (window.location.pathname.indexOf('wynajem') !== -1) {
            setFinancing('subscription');
        } else {
            setFinancing('leasing');
        }
    };

    checkMaintenance();

    $('.data-act-link').click(function () {
        $('body').addClass('no-scroll-body');
        $('.data-act-modal-wrapper').show();
    });

    $('.close-icon-modal, .data-act-modal-wrapper').click(function () {
        $('body').removeClass('no-scroll-body');
        $('.data-act-modal-wrapper').hide();
    });

    $('.data-act-modal').click(function (e) {
        e.stopPropagation();
    });
});

function findGetParameter(parameterName) {
    var result = '',
        tmp = [];
    var items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}

function setFinancing(name) {
    $("html, body").animate({scrollTop: 0}, 300);
    if (name === 'leasing') {
        lcv.form.init('.order-form', 'leasing');
        loaderStart('leasing');
        window.history.pushState('', '', base_url + 'leasing');
        tracking.adobe.changeFinancing('leasing');
    } else {
        lcv.form.init('.order-form', 'subscription');
        loaderStart('subscription');
        window.history.pushState('', '', base_url + 'wynajem');
        tracking.adobe.changeFinancing('wynajem');
    }

    // ADOBE //
    if (typeof window.digitalData !== 'undefined') {
        _satellite.track("pageload");
    }

    if (financing[name][lcv.field.model.val()] !== undefined) {
        tracking.adobe.changeType(lcv.field.cta.val());

        tracking.adobe.changeModelForForm(
            lcv.field.cta.val(),
            financing[name][lcv.field.model.val()]['adobe_VehicleID'],
            financing[name][lcv.field.model.val()]['adobe_VehicleModel'],
            financing[name][lcv.field.model.val()]['adobe_VehicleModelName'],
            financing[name][lcv.field.model.val()]['adobe_vehicleEngine'],
            financing[name][lcv.field.model.val()]['adobe_VehicleTrim']);
    }
    // / ADOBE //
}

function lazyLoad(){
    var lazy = document.getElementsByClassName('lazy');

    for(var i = 0; i < lazy.length; i++) {
        if(isInViewport(lazy[i]) || lazy[i].getAttribute('data-load') === 'true'){
            if (lazy[i].getAttribute('data-loaded') !== 'true' && $(lazy[i]).css('display') !== 'none') {
                if (msieversion() !== false ) {
                    if(lazy[i].getAttribute('data-ie-type') === 'jpg') {
                        lazy[i].src = lazy[i].getAttribute('data-src').replace('.webp', '.jpg');
                    }else if(lazy[i].getAttribute('data-ie-type') === 'png') {
                        lazy[i].src = lazy[i].getAttribute('data-src').replace('.webp', '.png');
                    } else {
                        lazy[i].src = lazy[i].getAttribute('data-src');
                    }
                } else {
                    lazy[i].src = lazy[i].getAttribute('data-src');
                }
                lazy[i].setAttribute('data-loaded', 'true');
            }
        }
    }
}

function isInViewport(el){
    var rect = el.getBoundingClientRect();

    if(window.isScroll === 1) {
        return false;
    } else {
        return (
            rect.bottom >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }
}

function registerListener(event, func) {
    if (window.addEventListener) {
        window.addEventListener(event, func)
    }
}

function msieversion() {
    if (window.document.documentMode !== undefined) {
        return parseInt(window.document.documentMode);
    } else {
        return false;
    }
}


function sendFloodlight(activityID, type, cat) {
    if ($('.iframe-floodlight-' + cat).length) {
        $('.iframe-floodlight-' + cat).remove();
    }

    var axel = Math.random() + "";
    var a = axel * 10000000000000;
    var newIframe = document.createElement('iframe');
    newIframe.height = '1';
    newIframe.width = '1';
    newIframe.style.display = 'none';
    newIframe.className = 'iframe-floodlight-' + cat;

    newIframe.src = 'https://' + activityID + '.fls.doubleclick.net/activityi;src=' + activityID + ';type=' + type + ';cat=' + cat +
        ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?;';
    document.body.appendChild(newIframe);
}

function loaderStart(financing) {
    if (window.innerWidth > 480) {
        var $body = $('body');
        $('.container-loader').css('z-index', 5000);
        // $body.removeClass('').addClass('restart');
        $body.removeClass('loaded').addClass('restart');
        loader( 100, financing);
    } else {
        $('.loader-big').addClass('show').removeClass('hide');
        restartFinancing(financing);
        setTimeout(function() {
            $('.loader-big').addClass('hide').removeClass('show');
        }, 1500);
    }
}

function loader(delay, financing) {
    var $body = $('body');
    setTimeout(function(){
        $body.addClass('loading');
    }, delay);

    setTimeout(function(){
        $body.addClass('loaded');
    }, delay + 1700);

    setTimeout(restartFinancing, delay + 2200, financing);

    setTimeout(function(){
        $('.container-loader').css('z-index', 0);
    }, delay + 1700 + 3000);
}


function restartFinancing (financing) {
    let $contentLeasing = $('.content-leasing'),
      $contentSubscription = $('.content-subscription');

    if (financing === 'leasing') {
        $('.logo-leasing').addClass('active');
        $('.logo-subscription').removeClass('active');
        $contentLeasing.show();
        $contentSubscription.hide();
        $contentLeasing.removeClass('hidden');
        $contentSubscription.addClass('hidden');
        $('.site').addClass('leasing').removeClass('subscription');
        // $('[data-financing-nav]').text('Co to jest Leasing 102,9%?');
        document.title = 'Fiat Professional - leasing | Samochody dostawcze w leasingu';
        selected.financing = 'leasing';
        AOS.refreshHard();
        // lcv.$carouselLeasing.slick('resize');

        const activeVisualModel = $('.content-subscription.carousel-nav__item.is-active').attr('data-car-slug');
        const activeVisualModelId = lcv.$carouselLeasing.find('.carousel__item.carousel__item--' + activeVisualModel).attr('data-carousel-slick-index') || 0;
        lcv.$carouselLeasing.slick('slickGoTo', activeVisualModelId);
        lcv.$carouselLeasing.slick('setPosition');
    } else {
        $('.logo-leasing').removeClass('active');
        $('.logo-subscription').addClass('active');
        $contentLeasing.hide();
        $contentSubscription.show();
        $contentLeasing.addClass('hidden');
        $contentSubscription.removeClass('hidden');

        $('.site').addClass('subscription').removeClass('leasing');
        // $('[data-financing-nav]').text('Wynajem długoterminowy');
        document.title = 'Fiat Professional - wynajem | Samochody dostawcze w wynajmie długoterminowym';
        selected.financing = 'wynajem';
        AOS.refreshHard();
        // lcv.$carouselSubscription.slick('resize');

        const activeVisualModel = $('.content-leasing.carousel-nav__item.is-active').attr('data-car-slug');
        const activeVisualModelId = lcv.$carouselSubscription.find('.carousel__item.carousel__item--' + activeVisualModel).attr('data-carousel-slick-index') || 0;
        lcv.$carouselSubscription.slick('slickGoTo', activeVisualModelId);
        lcv.$carouselSubscription.slick('setPosition');
    }

    checkMaintenance();
}

function checkMaintenance() {
    if(selected.financing === 'leasing' && offer.leasing === '') {
        $('.carousel__button').hide();
        $('.carousel__model').hide();
        $('.slider__thumb').hide();
        $('.navigation').hide();
        $('#section-one').hide();
        $('#section-two').hide();
        $('#section-three').hide();
        $('#section-models').hide();
        $('.form__h2').show();
        // $('#section-form').show();
        $('.footer__left').hide();
        $('.footer__right').hide();

        $('body').addClass('maintenance');
    } else if(selected.financing === 'wynajem' && offer.subscription === '') {
        $('.carousel__button').hide();
        $('.carousel__model').hide();
        $('.slider__thumb').hide();
        $('.navigation').hide();
        $('#section-one').hide();
        $('#section-two').hide();
        $('#section-three').hide();
        $('#section-models').hide();
        $('.form__h2').show();
        // $('#section-form').show();
        $('.footer__left').hide();
        $('.footer__right').hide();

        $('body').addClass('maintenance');
    } else {
        $('.carousel__button').show();
        $('.carousel__model').show();
        $('.slider__thumb').show();
        $('.navigation').show();

        $('#section-one').show();
        $('#section-two').show();
        $('#section-three').show();
        $('#section-models').show();
        // $('#section-form').show();

        $('.form__h2').hide();
        $('.footer__left').show();
        $('.footer__right').show();

        $('body').removeClass('maintenance');
    }
}


